const utils = {
  formStateBuilder: (formData) => {
    let state = {};
    formData.fields.map((item) => {
      if (item.component === "checkbox") {
        state[item.key] = false;
      } else {
        state[item.key] = "";
      }
    });
    return state;
  },

  currentDate: () => {
    var today = new Date();
    let temp;
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    temp = yyyy + "-" + mm + "-" + dd;
    return temp;
  },
  shopifyNewCustomerFormat: (data) => {
    let newData = { ...data };
    newData["addresses"] = [{}];
    if (data["address1"]) {
      newData["addresses"][0]["address1"] = data["address1"];
      delete newData.address1;
    }
    if (data["zip"]) {
      newData["addresses"][0]["zip"] = data["zip"];
      delete newData.zip;
    }
    delete newData[undefined];
    return newData;
  },
};
export default utils;
